<template>
  <div class="mt-5">
    <ul
      class="steps d-flex justify-content-between p-0 "
      :class="[{'steps--active': stepActive > 0} ]"
      >
      <li v-for="(step, i) in steps" :key="i"
        class="step"
        :class="{'step--active': step <= stepActive }"
      >0{{step}}</li>
    </ul>
    <span class="stepsLine">
      <div class="stepProgress" :style="`width:${progress}%`"></div>
    </span>
  </div>
</template>

<script>
export default {
  name: "Steps",
  props:{
    steps: {
      type: Number,
      required: true
    },
    stepActive:{
      type: Number,
      required: true
    },
    progress :{
      type: Number,
      required: true
    }
  },
}
</script>
<style lang="scss" scoped>

div {
  position: relative;
  overflow: hidden;
}

.stepsLine {
  position: absolute;
  z-index: 1;
  top: 35%;
  left: 50px;
  display: inline-block;
  width: calc(100% - 100px);
  height: 3px;
  background: #3a435a;

  .stepProgress {
    height: 3px;
    background-image: linear-gradient(to right, #ff5924 0%,  #ff5924 80%, transparent 100%)
  }
}

.step {
  border: 2px solid transparent;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background: #3a435a;
  text-align: center;
  color: white;
  line-height: 45px;
  font-size: 20px;
  z-index: 2;

  &--active {
    border: 2px solid #ff5924;
  }
}
</style>
